import { render, staticRenderFns } from "./charge_order_page.vue?vue&type=template&id=f288fc0c&scoped=true"
import script from "./charge_order_page.vue?vue&type=script&lang=js"
export * from "./charge_order_page.vue?vue&type=script&lang=js"
import style0 from "./charge_order_page.vue?vue&type=style&index=0&id=f288fc0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f288fc0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f288fc0c')) {
      api.createRecord('f288fc0c', component.options)
    } else {
      api.reload('f288fc0c', component.options)
    }
    module.hot.accept("./charge_order_page.vue?vue&type=template&id=f288fc0c&scoped=true", function () {
      api.rerender('f288fc0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/charge_order_page.vue"
export default component.exports